import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
  LISTING_ITEM_FLAW_ROWS,
} from '../../constants/listingItemFlaws';

const Field = styled.div`
  margin-bottom: 1rem;
`;

const Question = styled.p`
  margin: 0 0 0.65rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary, #111827);
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem 1rem;
  margin-bottom: 0.55rem;
`;

const OptionLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.92rem;
  color: var(--text-primary, #111827);
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
`;

const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  accent-color: #10b981;
  cursor: pointer;
`;

export default function ListingItemFlawsField({ value = [], onChange }) {
  const { t } = useTranslation();
  const selected = Array.isArray(value) ? value : [];

  const toggle = (key) => {
    if (!onChange) return;
    if (selected.includes(key)) {
      onChange(selected.filter((entry) => entry !== key));
      return;
    }
    onChange([...selected, key]);
  };

  return (
    <Field>
      <Question>{t('listing.flawsAnyFollowing')}</Question>
      {LISTING_ITEM_FLAW_ROWS.map((row, rowIndex) => (
        <Row key={`flaw-row-${rowIndex}`}>
          {row.map((key) => (
            <OptionLabel key={key}>
              <Checkbox
                type="checkbox"
                checked={selected.includes(key)}
                onChange={() => toggle(key)}
              />
              {t(`listing.flawLabels.${key}`)}
            </OptionLabel>
          ))}
        </Row>
      ))}
    </Field>
  );
}
